import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './i18n/config';
import LanguageProvider from './i18n/LanguageProvider';

// ResizeObserver fires this harmless warning when grid tiles resize rapidly.
// Suppress it so it doesn't pollute the dev overlay.
const _origError = window.onerror;
window.onerror = (msg, ...rest) => {
    if (typeof msg === "string" && msg.includes("ResizeObserver loop")) return true;
    return _origError ? (_origError as any)(msg, ...rest) : false;
};

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// react-snap pre-renders the public marketing routes to static HTML at build time.
// When that pre-rendered markup is present (production), hydrate it so the copy +
// JSON-LD in the served HTML aren't thrown away. Otherwise — in dev, or before the
// JS bundle mounts — mount fresh. The pre-JS loading spinner lives inside #root, so
// its presence means "not pre-rendered".
if (rootElement.hasChildNodes() && !document.getElementById('app-loading')) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

reportWebVitals();
